
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";
import { TSelect } from "@/models/autocomplete";
import { debounce } from "throttle-debounce-ts";

const CUSTOM_SELECT_ITEM_MARKER = ";;customSelectItem;;";

const DEBOUNCE_TIMEOUT = 500;

@Component
export default class AnswerBlockCompaniesHouseAutocomplete extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: 0 }) readonly index!: number;
  @Prop({ type: Number, default: 0 }) readonly loopIndex!: number;

  input = "";

  options: TSelect[] = [];

  loading = false;

  fetchOptions(val: string) {
    if (!val) return;

    SMQuestionnaire.setCanGoNext(false);

    const searchFunc = debounce(DEBOUNCE_TIMEOUT, async () => {
      try {
        this.loading = true;

        const { data } = await this.axios.get(this.answerBlockData.url, {
          params: {
            q: encodeURIComponent(val),
          },
        });

        if (!data?.items) return;

        this.options = data.items.map((v: any) => ({
          value: v.value,
          label: v.title,
        }));
      } finally {
        this.loading = false;
      }
    });

    if (!this.loading) searchFunc();
  }

  @Watch("input")
  updateAnswer() {
    if (this.loading || !this.input) return;

    SMQuestionnaire.updateAnswer({
      index: this.index,
      value: this.input,
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
    });
  }

  async created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index === null || !answer?.value) {
      this.loading = false;

      return;
    }

    await this.fetchOptions(answer.value);

    this.input =
      this.options.find((option) => option.label === answer.value)?.value ?? answer.value;
  }

  async clean() {
    this.input = "";

    await this.$nextTick();

    SMQuestionnaire.setCanGoNext(false);
  }

  atCustomInput(value: string) {
    SMQuestionnaire.updateAnswer({
      index: this.index,
      value: `${value}${CUSTOM_SELECT_ITEM_MARKER}`,
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
    });
  }
}
